import { type MutableRefObject, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { AgGrid } from "@jsq/ds/core";

/**
 * Purge the SSRM grid when the nested link-case takeover closes. The takeover renders over the
 * still-mounted table, so returning from it doesn't remount the grid — without this, a newly
 * linked case (which changes onboarding status) wouldn't show until a manual refresh.
 */
export const useRefreshOnLinkCaseClose = (
  gridApiRef: MutableRefObject<AgGrid.GridApi | null>,
  linkCaseSegment: string,
) => {
  const { pathname } = useLocation();
  const onLinkCaseRoute = pathname.includes(linkCaseSegment);
  const wasOnLinkCaseRoute = useRef(onLinkCaseRoute);

  useEffect(() => {
    if (wasOnLinkCaseRoute.current && !onLinkCaseRoute) {
      gridApiRef.current?.refreshServerSide({ purge: true });
    }
    wasOnLinkCaseRoute.current = onLinkCaseRoute;
  }, [onLinkCaseRoute, gridApiRef]);
};
